<template>
  <section class="contact container">
    <h2>{{ $t('nav.contact') }}</h2>

    <div class="contact-info">
      <div class="contact-item">
        <i class="el-icon-phone-outline"></i>
        <span>{{ $t('contact.phone') }}：<a href="tel:18665886416">18665886416</a></span>
      </div>

      <div class="contact-item">
        <i class="el-icon-message"></i>
        <span>{{ $t('contact.email') }}：<a href="mailto:fengtao@yebozhineng.com">fengtao@yebozhineng.com</a></span>
      </div>

      <div class="contact-item wechat">
        <i class="el-icon-chat-dot-round"></i>
        <span>{{ $t('contact.wechat') }}：</span>
        <div class="wechat-box">
          <img src="../assets/wechat_qr.png" alt="WeChat QR Code" class="wechat-qrcode" />
          <p>{{ $t('contact.scanAdd') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style scoped>
.contact {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(11,127,198,0.05);
  text-align: center;
}

.contact-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin-top: 20px;
}

.contact-item {
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.contact-item a {
  color: #007bff;
  text-decoration: none;
}

.contact-item.wechat {
  flex-direction: column;
  align-items: center;
}

.wechat-box {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wechat-qrcode {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  object-fit: cover;
}
</style>
